import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import LinearProgress from "@mui/material/LinearProgress";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useEffect, useState } from "react";
import * as React from "react";
import { useHistory } from "react-router-dom";
import Layout from "../../components/layout";
import userService from "../../services/UserService";
import ValidationModal from "../BootstrapValidationModal";
import PhoneInput from "react-phone-input-2";
import { EncryptData } from "../../helpers/helper";
import "react-phone-input-2/lib/style.css";
// import { Box, Chip } from '@mui/joy';

export default function NewUser() {
  const history = useHistory();

  const [progress, setProgress] = React.useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingModalOpen, setIsSubmittingModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fullName, setfullName] = useState("");
  const [fullNameError, setfullNameError] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState(false);
  const [selectedOptions, setSelectedOptions] = React.useState(0);
  const [selectedOptionsError, setSelectedOptionsError] = React.useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    if (name === "password") {
      setPassword(value);

      if (value.length < 6) {
        setPasswordError(true);
      } else {
        setPasswordError(false);
      }
    }
    if (name === "address") {
      setAddress(value);
      if (value !== "") {
        setAddressError(false);
      } else {
        setAddressError(null);
      }
    } else if (name === "email") {
      setEmail(value);
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value === "") {
        setEmailError(false);
      } else if (!emailRegex.test(value)) {
        // If the value doesn't match the email format, set an error
        setEmailError(true);
      } else {
        // If the value is valid, clear the error
        setEmailError(false);
      }
    } else if (name === "phone") {
      setPhoneNumber(value);

      // Define a regex for phone number validation
      const phoneRegex =
        /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,9}$/;

      if (value === "") {
        setPhoneNumberError(false);
      } else if (!phoneRegex.test(value)) {
        // If the value doesn't match the phone number format, set an error
        setPhoneNumberError(true);
      } else {
        // If the value is valid, clear the error
        setPhoneNumberError(false);
      }
    } else if (name === "fullName") {
      setfullName(value);

      if (value === "") {
        setfullNameError(true);
      } else {
        setfullNameError(false);
      }
    }
  };

  useEffect(() => {
    let intervalId;
    let isMounted = true;

    const startProgress = () => {
      intervalId = setInterval(() => {
        setProgress((oldProgress) => {
          const newProgress = oldProgress + 100 / steps;
          if (newProgress >= 100) {
            clearInterval(intervalId);
            setTimeout(() => {
              if (isMounted) {
                setIsSubmittingModalOpen(false);
                history.push(`/users`);
              }
            }, 500);
            return 100;
          }
          return newProgress;
        });
      }, intervalDuration);
    };

    const intervalDuration = 30;
    const totalTime = 1000;
    const steps = totalTime / intervalDuration;

    if (isSubmittingModalOpen) {
      startProgress();
    }

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [isSubmittingModalOpen]);

  const onSubmit = async (record) => {
    const storedUser = await localStorage.getItem("user");
    const parsedData = JSON.parse(storedUser);

    let error = 0;
    if (fullName === "") {
      setfullNameError(true);
      error += 1;
    } else {
      setfullNameError(false);
    }
    if (address === "") {
      error += 1;
      setAddressError(true);
    }
    if (email === "") {
      error += 1;
      setEmailError(true);
    }
    if (phoneNumber === "") {
      error += 1;
      setPhoneNumberError(true);
    }
    if (selectedOptions === 0) {
      error += 1;
      setSelectedOptionsError(true);
    }
    if (password === null) {
      setPasswordError(true);
      error += 1;
    }
    if (error > 0) {
      setIsModalOpen(true);
      return;
    } else {
      setIsModalOpen(false);
    }

    setIsSubmitting(true);
    try {
      const payload = {
        full_name: EncryptData(fullName),
        password,
        phone_no: EncryptData(phoneNumber),
        email: EncryptData(email),
        roleId: selectedOptions,
        createdById: parsedData.id,
        address: EncryptData(address),
      };

      setIsSubmitting(false);
      try {
        await userService.save(payload);
      } catch (error) {
        console.error("this is an error", error.message);
      }

      setIsSubmittingModalOpen(true);
    } catch {
      setIsSubmitting(false);
    }
  };

  const closeSubmittingModal = () => {
    setIsSubmittingModalOpen(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Layout>
      <div className="leavesIndex">
        <h4 className="attendance_overview_heading">Add New user</h4>

        <div className="leavesIndex__body">
          <div className="leavesIndex__body_padding">
            <Box
              component="form"
              noValidate
              sx={{
                display: "grid",
                gridTemplateColumns: { sm: "1fr 1fr" },
                gap: 2,
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "1vw",
                  }}
                >
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Full Name
                    </InputLabel>
                    <FormControl
                      className={`newLeaveScreen  ${
                        fullNameError ? "leaveDurationInput-error" : ""
                      }`}
                      variant="standard"
                    >
                      <OutlinedInput
                        name="fullName"
                        onChange={handleChange}
                        value={fullName}
                        placeholder="Enter Full Name"
                      />
                    </FormControl>
                  </div>
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Select Role
                    </InputLabel>
                    <select
                      name="user_exist"
                      id="user_exist"
                      className={`leaveDurationInput ${
                        selectedOptionsError ? "leaveDurationInput-error" : ""
                      }`}
                      onChange={(e) =>
                        setSelectedOptions(Number(e.target.value))
                      }
                      value={selectedOptions}
                    >
                      <option value={0}>Select Role</option>
                      <option value={4}>Super Admin</option>
                      <option value={1}>Admin</option>
                      <option value={2}>Staff</option>
                    </select>
                  </div> 
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "1vw",
                  }}
                >
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Email
                    </InputLabel>
                    <FormControl
                      className={`newLeaveScreen  ${
                        emailError ? "leaveDurationInput-error" : ""
                      }`}
                      variant="standard"
                    >
                      <OutlinedInput
                        name="email"
                        onChange={handleChange}
                        value={email}
                        placeholder="Enter Email"
                      />
                    </FormControl>
                  </div>
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Phone Number
                    </InputLabel>

                    <FormControl
                      className={`newLeaveScreen ${
                        phoneNumberError ? "leaveDurationInput-error" : ""
                      }`}
                      variant="standard"
                    >
                      <PhoneInput
                        country={"pk"}
                        value={phoneNumber}
                        onChange={(phone) => setPhoneNumber(phone)}
                        inputStyle={{ width: "90%", minHeight: "60px" }} // optional styling
                      />
                    </FormControl>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "1vw",
                  }}
                >
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Address
                    </InputLabel>
                    <FormControl
                      className={`newLeaveScreen  ${
                        addressError ? "leaveDurationInput-error" : ""
                      }`}
                      variant="standard"
                    >
                      <OutlinedInput
                        name="address"
                        onChange={handleChange}
                        value={address}
                        placeholder="Enter Address"
                      />
                    </FormControl>
                  </div>
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Password
                    </InputLabel>
                    <FormControl
                      className={`newLeaveScreen  ${
                        passwordError ? "leaveDurationInput-error" : ""
                      }`}
                      variant="standard"
                    >
                      <OutlinedInput
                        name="password"
                        onChange={handleChange}
                        value={password}
                        placeholder="Enter Password"
                      />
                    </FormControl>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="singleInputField"></div>
                <div className="singleInputField">
                  <div className="formButton">
                    <button
                      type="button"
                      disabled={isSubmitting}
                      className="formSubmitButton"
                      onClick={onSubmit}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </div>

        <ValidationModal
          isOpen={isSubmittingModalOpen}
          onClose={closeSubmittingModal}
        >
          <div className="modal__popup">
            <div className="Portal-Login-Form">
              <div className="ProgressModal">
                <Box className="progressOfSubmitting" sx={{ width: "100%" }}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      height: 15,
                      borderRadius: 10,
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#719879",
                      },
                    }}
                  />
                </Box>
                <span>Submitting Request</span>
              </div>
            </div>
          </div>
        </ValidationModal>
        <ValidationModal isOpen={isModalOpen} onClose={closeModal}>
          <div className="modal__popup">
            <div className="Portal-Login-Form">
              <div className="ValidationModal">
                <span>Please Enter All Fields To Continue!</span>

                <div className="CloseValidationModalButton">
                  <button
                    type="button"
                    disabled={isSubmitting}
                    className="CloseValidationModal"
                    onClick={closeModal}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidationModal>
      </div>
    </Layout>
  );
}
